/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_IntroInputs */

const en_svc_n8n_intro = /** @type {(inputs: Svc_N8n_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We design and build n8n workflows that move work between your tools and use AI where it helps: reading emails, extracting data, drafting replies. Documented, monitored, and owned by someone when something fails.`)
};

const lv_svc_n8n_intro = /** @type {(inputs: Svc_N8n_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mēs projektējam un veidojam n8n darba plūsmas, kas pārvieto darbu starp Jūsu rīkiem un izmanto AI tur, kur tas palīdz: e-pastu lasīšanai, datu ieguvei, atbilžu sagatavošanai. Dokumentētas, uzraudzītas un ar atbildīgo, ja kaut kas noiet greizi.`)
};

/**
* | output |
* | --- |
* | "We design and build n8n workflows that move work between your tools and use AI where it helps: reading emails, extracting data, drafting replies. Documented,..." |
*
* @param {Svc_N8n_IntroInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_intro = /** @type {((inputs?: Svc_N8n_IntroInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_IntroInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_intro(inputs)
	return en_svc_n8n_intro(inputs)
});